import styled from 'styled-components';

export const StyledFieldLabel = styled.label`
  display: block;
  margin-bottom: ${(p) => p.theme.space[1]};
`;
